import { render, staticRenderFns } from "./StoreOpenInquirePostShow.vue?vue&type=template&id=515b619f&"
import script from "./StoreOpenInquirePostShow.vue?vue&type=script&lang=js&"
export * from "./StoreOpenInquirePostShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports